export const scrollBlockEffect = () => {
  const { scrollX, scrollY } = window
  const keepScrollPosition = () => window.scrollTo(scrollX, scrollY)
  window.addEventListener('scroll', keepScrollPosition)
  return () => window.removeEventListener('scroll', keepScrollPosition)
}
